import qs from 'qs'
import { getUriComponents } from '~/utils/routing/uriUtils'

import { PaginatedApiResult } from '@mangovoice/types'

export const getPaginatedResultParts = <T>(
  paginatedApiResult: PaginatedApiResult<T>,
) => {
  if (!paginatedApiResult) return undefined

  const { results, next, previous, count } = paginatedApiResult
  const hasNextPage = !!next
  const hasPreviousPage = !!previous

  const nextPageParts = getUriComponents(next ?? '')
  const previousPageParts = getUriComponents(previous ?? '')

  const nextPageOffset = parseInt(
    (nextPageParts?.query?.params?.offset ?? 0) as string,
  )

  const previousPageOffset = parseInt(
    (previousPageParts?.query?.params?.offset ?? 0) as string,
  )

  const isLastPage = !hasNextPage
  const isFirstPage = !hasPreviousPage
  const currentPage = Math.floor(nextPageOffset / count)

  return {
    results,
    hasNextPage,
    hasPreviousPage,
    nextPageOffset,
    previousPageOffset,
    isLastPage,
    isFirstPage,
    currentPage,
    totalCount: count,
  }
}

export const getOrderingString = <T>(
  ordering?: OrderingField<T> | OrderingField<T>[],
) => {
  if (Array.isArray(ordering)) {
    return ordering.join(',')
  }
  return ordering
}

export const stringifyQueryParams = (params: object) => {
  return qs.stringify(params, {
    addQueryPrefix: false,
    arrayFormat: 'comma',
    encode: false,
  })
}
